module.exports = __webpack_public_path__ + "img/d3386953da6a7d8e5565d3baa4a6351b.svg";